import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import Swal from 'sweetalert2';
import { swalWarning } from '../shared/config/swalCommon';

@Directive({ selector: '[appNgDropFiles]' })

export class NgDropFilesDirective {
  @Input() acceptFile: string[];
  @Input() files: File[] = [];
  @Input() multiple: boolean;
  @Input() maxSize: number;
  @Input() scale: string;
  @Output() mouseSobre: EventEmitter<boolean> = new EventEmitter();
  @Output() detectDrop: EventEmitter<any> = new EventEmitter();
  constructor() { }

  @HostListener('dragover', ['$event'])
  public onDragEnter(event: any) {
    this.mouseSobre.emit(true);
    this._prevenirDetener(event);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: any) {
    this.mouseSobre.emit(false);
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: any) {
    const transferencia = this.getTransferencia(event);
    if (!transferencia) { return; }
    if (transferencia.files.length > 1 && !this.multiple) { Swal.fire(swalWarning('No se puede seleccionar mas de un archivo!')); return; }
    this._prevenirDetener(event);
    this.files = this.changeFiles(transferencia.files, this.files, this.acceptFile, this.multiple, this.maxSize, this.scale);
    this.mouseSobre.emit(false);
  }

  private getTransferencia = (event: any): DataTransfer => event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;

  public changeFiles(fileList: FileList, files: File[], fileTypes: string[], multiple: boolean, maxSize?: number, scale?: string) {
    const realSize = this.convertSize(maxSize, scale);
    if (this.files.length >= 1 && !multiple) { this.files.splice(0, 1); }
    Object.keys(fileList).forEach(key => (realSize && fileList[key].size > realSize) ?
      Swal.fire(swalWarning('¡El archivo es muy grande!', `¿El archivo no debe se mayor a ${maxSize} ${scale}!`)) :
      (!files.find(x => x.name === fileList[key].name)) ? (fileTypes.find(x => fileList[key].type.includes(x)) ||
        fileTypes.find(x => fileList[key].name.includes(x))) ? files.push(fileList[key]) : Swal.fire(swalWarning('¡Usted ha seleccionado archivos no validos!')) : Swal.fire(swalWarning('Ya ha agregado este archivo!')));
    this.detectChange();
    return files;
  }

  convertSize = (size: number, scale: string) =>
    (scale === 'KB') ? (size * 1024) : (scale === 'MB') ? (size * 1048576) : size

  detectChange = () => this.detectDrop.emit();

  private _prevenirDetener(event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
